/**
 * Groupes de richfields attendus côté back-office marque.
 *
 * §6.3 du plan : `group` est un champ texte libre, saisi dans un bloc
 * `superAdmin` — donc invisible du client. L'affectation est une opération
 * Placeloop faite une fois au paramétrage, ou via l'import JSON. Ces valeurs
 * sont donc un contrat, pas une préférence.
 *
 * Le `view_kind` conditionne les champs que le client pourra remplir :
 *  - NEWSFEED      → icon, title, cta_label, cta_target, desc, image (le plus riche)
 *  - IMAGE_BANNER  → image, cta_target
 * D'où le choix ci-dessous — mettre TARIFS ou EXPERTISES ailleurs qu'en NEWSFEED
 * empêcherait physiquement la saisie des titres et descriptions.
 */
export const RICHFIELD_KEYS = {
  SALON: 'SALON',
  PLAN_CANON: 'PLAN_CANON',
  TARIFS: 'TARIFS',
  EXPERTISES: 'EXPERTISES',
  COLLECTION: 'COLLECTION',
};

/** `view_kind` attendu par groupe — à respecter au paramétrage (plan §15.6). */
export const RICHFIELD_VIEW_KINDS = {
  [RICHFIELD_KEYS.SALON]: 'IMAGE_BANNER',
  [RICHFIELD_KEYS.PLAN_CANON]: 'NEWSFEED',
  [RICHFIELD_KEYS.TARIFS]: 'NEWSFEED',
  [RICHFIELD_KEYS.EXPERTISES]: 'NEWSFEED',
  [RICHFIELD_KEYS.COLLECTION]: 'NEWSFEED',
};

export default RICHFIELD_KEYS;
